import * as environment from 'OK/utils/environment';
import * as cookie from 'OK/cookie';

type TArgs = (PropertyKey | object)[];

const emptyFn = () => {};
export const isDebug = environment.isDebug && (cookie.readCookie('banners-debug') === 'true');

export function log(...args: TArgs) {
    if (isDebug) {
        const _args = ['[native banner]', ...args, ...arguments];
        console.log(..._args);
    }
}

export function createLog(name: string): (...args: TArgs) => void {
    return isDebug
      ? (...args) => {
            const _args = [`[native banner / ${name}]`, ...args];
            console.log(..._args);
        }
      : emptyFn;
}

export function getEffectiveViewportHeight() {
    const minToolbarHeight = window.OK.topPanelHeight();
    return window.innerHeight - minToolbarHeight;
}
